import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { ToggleRequirementItem } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/components/ToggleRequirementItem.tsx';
import { ENTITY_TABS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/types.ts';
import {
	IndividualInvestorSettings,
	InvestmentVehicleSettings,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/types.ts';
import {
	INDIVIDUAL_ROWS,
	VEHICLE_ROWS,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/components/InvestorDataRequirementsList.utils';

interface Props {
	type: ENTITY_TABS;
	individualSettings: IndividualInvestorSettings;
	vehicleSettings: InvestmentVehicleSettings;
	toggleIndividualSetting: (key: keyof IndividualInvestorSettings) => void;
	toggleVehicleSetting: (key: keyof InvestmentVehicleSettings) => void;
	hasPermission: boolean;
}

export const InvestorDataRequirementsList = ({
	type,
	individualSettings,
	vehicleSettings,
	toggleIndividualSetting,
	toggleVehicleSetting,
	hasPermission,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	if (type === ENTITY_TABS.INDIVIDUAL) {
		return (
			<>
				{INDIVIDUAL_ROWS.map(({ key, translationKey, defaults }) => (
					<ToggleRequirementItem
						key={key}
						title={tMipManage(
							`${translationKey}.label`,
							defaults ? { defaultValue: defaults.label } : undefined
						)}
						description={tMipManage(
							`${translationKey}.description`,
							defaults ? { defaultValue: defaults.description } : undefined
						)}
						checked={individualSettings[key].checked}
						disabled={individualSettings[key].disabled || !hasPermission}
						onToggle={() => toggleIndividualSetting(key)}
					/>
				))}
			</>
		);
	}

	return (
		<>
			{VEHICLE_ROWS.map(({ key, translationKey }) => (
				<ToggleRequirementItem
					key={key}
					title={tMipManage(`${translationKey}.label`)}
					description={tMipManage(`${translationKey}.description`)}
					checked={vehicleSettings[key].checked}
					disabled={vehicleSettings[key].disabled || !hasPermission}
					onToggle={() => toggleVehicleSetting(key)}
				/>
			))}
		</>
	);
};
